import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { ConsultorioPrivadoRequest, ConsultorioPrivadoResponse } from './consultorio-privado.model';

@Injectable({ providedIn: 'root' })
export class ConsultorioPrivadoService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pessoaFisica.consultorioPrivado;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: ConsultorioPrivadoRequest, context?: HttpContext): Observable<ConsultorioPrivadoResponse> {
        const httpParams = new HttpParams().set('numeroProtocolo', params.numeroProtocolo).set('anoProtocolo', params.anoProtocolo).set('uf_crm', params.ufCrm);
        return this.http.get<ConsultorioPrivadoResponse>(this.PATH, { params: httpParams, context });
    }

    consultarAbertos(ufCrm: string, context?: HttpContext): Observable<Record<string, unknown>[]> {
        const httpParams = new HttpParams().set('uf_crm', ufCrm);
        return this.http.get<Record<string, unknown>[]>(`${this.PATH}/abertos`, { params: httpParams, context });
    }

    efetivarSolicitacao(dto: ConsultorioPrivadoResponse, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/efetivarSolicitacao`, dto, { context });
    }

    cancelarSolicitacao(dto: ConsultorioPrivadoResponse, motivo?: string, context?: HttpContext): Observable<void> {
        const params = motivo ? new HttpParams().set('motivo', motivo) : undefined;
        return this.http.put<void>(`${this.PATH}/cancelarSolicitacao`, dto, { params, context });
    }
}
